// extracted by mini-css-extract-plugin
export var body = "_cb-0";
export var sectionHeader = "_cb-4";
export var shortcutColumns = "_cb-2";
export var shortcutList = "_cb-1";
export var shortcutSection = "_cb-3";